/**
 * This module's slice of the translation catalogue.
 *
 * The console's `src/locales/{en,dv}.json` are hand-maintained and owned by the
 * app, not by a module. Rather than edit them from here — which is how one
 * feature's keys quietly overwrite another's — the geography and tax-pack
 * strings ship as **fragments** (`src/locales/fragments/geotax.*.json`) and are
 * merged into the live catalogue at import time.
 *
 * `mergeLocaleMessage` deep-merges, so the fragment's `errors.codes.*` subtree
 * joins the app's existing one instead of replacing it. The merge is idempotent
 * and runs once per locale on first import: `routes.ts` imports this file
 * eagerly (so the merge happens when the router is built, before any lazy view
 * loads) and every view imports it too, so a component mounted directly in a
 * test renders prose rather than raw keys.
 *
 * `locales.test.ts` guards the app catalogue; `locales.test.ts` in this folder
 * guards the fragments with the same rules — parity, Thaana, placeholders,
 * plural arms, and a review list naming every machine-drafted Dhivehi string.
 */

import { i18n } from '@/i18n'

import dv from '@/locales/fragments/geotax.dv.json'
import en from '@/locales/fragments/geotax.en.json'

let merged = false

export function registerGeotaxMessages(): void {
  if (merged) return
  merged = true
  i18n.global.mergeLocaleMessage('en', en)
  i18n.global.mergeLocaleMessage('dv', dv)
}

registerGeotaxMessages()
